import { render, staticRenderFns } from "./chargeRule.vue?vue&type=template&id=210e3e12&scoped=true&"
import script from "./chargeRule.vue?vue&type=script&lang=js&"
export * from "./chargeRule.vue?vue&type=script&lang=js&"
import style0 from "./chargeRule.vue?vue&type=style&index=0&id=210e3e12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210e3e12",
  null
  
)

export default component.exports